export const getMadeLists = ({ listsReducer: { madeLists } }) => madeLists;
export const getSongs = ({ listDetailsReducer: { songs } }) => songs;
